import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { BiInfoCircle } from 'react-icons/bi'
export default function Info({message}) {
  return (
    <>
    
      <OverlayTrigger
        delay={{ hide: 450, show: 300 }}
        overlay={(props) => (
          <Tooltip {...props}>
           {message}
          </Tooltip>
        )}
        placement="top"
      >
        <Button  style={{ padding: 0 ,border:'none',background:"none",boxShadow:"none"}} 
      variant="light" ><BiInfoCircle size={20} color='black' /></Button>
     
      </OverlayTrigger>
    </>
  );
}